(() => {
  if (window.__HF_ACCORDION_INIT__) return;
  window.__HF_ACCORDION_INIT__ = 1;

  function findGroupRoot(el) {
    return (
      el.closest('[data-accordion-root], .shopify-section') ||
      el.closest(
        '.product__accordion, .cart-rein, .accordion, .accordion-list, .collapsible, .collapsible-list, .drawer__inner, #MainContent, main'
      ) ||
      document.body
    );
  }

  document.addEventListener(
    'toggle',
    function (ev) {
      const acc = ev.target;
      if (!(acc instanceof HTMLDetailsElement)) return;
      if (!acc.open) return;

      const root = findGroupRoot(acc);
      const yBefore = acc.getBoundingClientRect().top + window.pageYOffset;

      root.querySelectorAll('details[open]').forEach((d) => {
        if (d !== acc && !d.contains(acc)) d.open = false;
      });

      requestAnimationFrame(() => {
        const yAfter = acc.getBoundingClientRect().top + window.pageYOffset;
        const delta = yAfter - yBefore;

        if (Math.abs(delta) > 1) {
          window.scrollTo({ top: window.pageYOffset + delta, behavior: 'auto' });
        }
      });
    },
    true
  );
})();